import genkey from '@/utils/genkey.js'
import { cloneDeep, keyBy } from 'lodash';

/**
 * 获取无法匹配到的规格列表
 * @param {*} productSpecRule 平台规格信息
 * @param {*} defaultSpecifications 详情里的规格信息
 * @returns 
 */
// const getUnmatchedSpecifications = (productSpecRule, defaultSpecifications) => {
//     const platformSpecifications = cloneDeep(productSpecRule);
//     defaultSpecifications.forEach(item => {
//         const matchIndex = platformSpecifications.findIndex(spec => {
//             const { valueRules = {} } = spec || {};
//             const name = valueRules.title || valueRules.name
//             return name && (name.includes(item.name) || item.name.includes(name));
//         });
//         if (matchIndex > -1) {
//             platformSpecifications.splice(matchIndex, 1, null)
//         }
//     });
//     return platformSpecifications.filter(item => !!item);
// }
/**
 * 查找匹配的规格项
 */
const findMatchedSpecIndex = (specList, defaultItem) => {
    const findSpecItemIndex = (condition) => {
        return specList.findIndex(sp => {
            const { title, name, features } = sp.valueRules || {};
            return condition(name || title, features);
        });
    };

    // 优先匹配可编辑图片的规格
    const colorSpec = findSpecItemIndex((name, features) => {
        const findColor1 = (features || []).find(f => f.key === 'color' && f.value == '1');
        return findColor1 && name === defaultItem.name;
    });
    if (colorSpec > -1) return colorSpec;

    // 精确匹配
    const exactMatch = findSpecItemIndex(name => name === defaultItem.name);
    if (exactMatch > -1) return exactMatch;

    // 模糊匹配
    return findSpecItemIndex(name => 
        name.includes(defaultItem.name) || defaultItem.name.includes(name)
    );
};

/**
 */
const createNeedlessSpecItem = (defaultItem) => {
    // 平台规格信息为空表示 基础资料规格数量比平台规格数量多
    // 拷贝基础资料中的规格信息，以自定义输入框��形式填充至页面
    const matchItem = cloneDeep(defaultItem);
    const { values = [] } = matchItem;
    matchItem.values = formatSpecValues(values, {});
    const needlessItem = {
        id: 0,
        name: matchItem.name,
        nameKey: matchItem.nameKey,
        ...matchItem,
        editPropertyName: true,
        valueItemRule: {
            id: 0,
            name: matchItem.name
        }
    }
    return needlessItem;
};

/**
 * /**
 * 生成京东规格明细
 * @param {*} schemaSpecs 平台返回的规则
 * @param {*} defaultSpecifications 默认的规格列表
 * @returns 
 */
export const gernerateJDSpecs = (schemaSpecs, defaultSpecifications = [], attrProperties={}) => {
    // 过滤出必填规格的name
    const requiredAttrNames = Object.values(attrProperties).filter(item => item.features.some(feat => feat.key == "required" && feat.fvalue == 1)).map(item => item.name)
    const colorItem = Object.values(attrProperties).find(item => item.features.some(feat => feat.key == "color" && feat.fvalue == 1))

    const allSaleProps = cloneDeep(schemaSpecs);
    const unrenderList = cloneDeep(schemaSpecs);
    const needlessSpecList = [];
    const newRequiredSpecDetails = [];
    // 先生成无法匹配的规格列表
    // 生成规格明细列表，需要完全依赖怒基础资料中的规格信息（主要是各个规格数量需要保持一致）
    // 采用下标顺序index:index将快麦通detail接口中的specifications与平台requiredSpecDetails 中的规格进行匹配
    defaultSpecifications.forEach((defaultItem, specIndex) => {
        if (!unrenderList.length) {
            // 处理平台规格信息为空的情况
            const needlessItem = createNeedlessSpecItem(defaultItem);
            newRequiredSpecDetails.push(needlessItem);
            needlessSpecList.push(needlessItem);
        } else {
            // 去和detail接口中的specifications进行匹配，如果有匹配到，则进行相应的赋值
            // 不匹配的情况，则从无法匹配的规格列表里优先取必填规格，无必填规格再按顺序获取
            let findMatchIndex = findMatchedSpecIndex(unrenderList, defaultItem);
            const hasMatch = findMatchIndex > -1;
            if (!hasMatch) {
                findMatchIndex = 0
                if(requiredAttrNames.length) { // 优先取必填规格
                    findMatchIndex = unrenderList.findIndex(item => (item.valueRules.title || item.valueRules.name) == requiredAttrNames[0]);
                    if(findMatchIndex > -1) {
                        requiredAttrNames.splice(0, 1);
                    }
                }
            }
            // const isColorItem = attrProperties[unrenderList[findMatchIndex].attrId]?.features?.some(f => f.key === 'color' && f.fvalue == '1')
            // if(specIndex == 0 && !isColorItem) {
            //     const findColorItem = Object.values(attrProperties).find(item => item.features.some(f => f.key == "color" && f.fvalue == 1))
            //     if(findColorItem) {
            //         findMatchIndex = unrenderList.findIndex(item => findColorItem.id === item.attrId);
            //     }
            // }
            let matchedSpecItem = unrenderList[findMatchIndex];

            // 平台规格和基础资料里的规格能逐一匹配到
            const { valueRules = {} } = matchedSpecItem;
            // 导航样式的数据需要特殊处理，需要重新请求接口获取规格值数据并替换掉接口返回的原propertyValues值
            // 规格项渲染所需要的平台参数
            const valueItemRule = valueRules;
            if (!valueItemRule.id) {
                valueItemRule.id = matchedSpecItem.attrId;
            }
            const matchedData = cloneDeep(defaultItem);
            const { values = [] } = matchedData;
            // 规格值项处理
            matchedData.values = formatSpecValues(values, matchedSpecItem);
            const requiredSpec = {
                ...matchedData,
                id: (valueRules.attrId || valueRules.id),
                valueItemRule,
                name: (valueRules.title || valueRules.name)
            };
            // 逐一匹配规格名字，从基础资料同步过来的数据，未经保存过可能会存在不匹配
            // 在系统二次保存后，也是在这里进行正常匹配。
            // 未匹配的数据需要特殊处理一下
            if (!hasMatch) {
                Object.assign(requiredSpec, {
                    nameKey: matchedData.nameKey,
                    valueKey: matchedData.valueKey,
                })
            }
            newRequiredSpecDetails.push(requiredSpec)
            unrenderList.splice(findMatchIndex, 1);
        }
    })
    if(colorItem) {
        const colorSpecIndex = newRequiredSpecDetails.findIndex(item => item.name === colorItem.name)
        if(colorSpecIndex > -1) {
            newRequiredSpecDetails.unshift(newRequiredSpecDetails.splice(colorSpecIndex, 1)[0])
        }
    }
    return {
        allSaleProps,
        newSpec: newRequiredSpecDetails,
        unrenderList,
        needlessSpecList
    };
}
/**
 * 处理规格值数据
 * @param {*} values 规格值
 * @param {*} specItem
 * @returns 
 */
export const formatSpecValues = (values = [], specItem = {}) => {
    const { valueRules } = specItem;
    const { attrValueList = [], items = [], id } = valueRules || {};

    return values.map(valueItem => {
        // let extendValues = valueItem.extendValues || {};
        let extendValues =  {};
        if (!attrValueList.length && items.length > 0) {
            let requireIndex = items.findIndex(i => i.required)
            items.forEach((ruleItem, rIndex) => {
                const id = ruleItem.properties.id.enum[0];
                let extendValue = valueItem.extendValues ? valueItem.extendValues[id] || {}: {};

                extendValue = {
                    id,
                    value: '',
                    valueId: '',
                    unit: '',
                    ...(typeof extendValue === 'string' ? 
                        JSON.parse(extendValue) || {} : 
                        extendValue)
                };
                // 如果extendValues中的值都是空的，则默认把 规格值赋值给extendValues的必填项或第一个值
                if(requireIndex === rIndex && !extendValue.value) {
                    extendValue.value = valueItem.value;
                }
                if (ruleItem.properties.id.type === 'model') {
                    const { preprocessingSaleAttrValTemplateValueList } = ruleItem.properties.value.enum[0];
                    if(preprocessingSaleAttrValTemplateValueList?.length && !preprocessingSaleAttrValTemplateValueList[0].children) {
                        const findItemP = matchMultiModelTempId(extendValue.value, preprocessingSaleAttrValTemplateValueList) || {};
                        extendValue.valueId = findItemP.id;
                    }
                    const matchItem = matchMultiModelTempId(extendValue.value, preprocessingSaleAttrValTemplateValueList, true);
                    if (matchItem) {
                        extendValue.firstTempId = matchItem.id;
                    }
                }
                extendValues[id] = extendValue
            });
        }
        return {
            ...gernerateDefaultSpecValueItem(specItem),
            nameKey: valueItem.nameKey,
            valueKey: valueItem.valueKey,
            checked: valueItem.checked,
            imageUrl: valueItem.imageUrl,
            value: valueItem.value,
            extendValues,
            propId: id || valueItem.propId || '',
            propValueId: valueItem.propValueId || '',
        };
    });
}
export const matchMultiModelTempId = (valueCN, templateValueList = [], multi) => {
    // 先判断是多层级的模板还是单层的模板，单层模板不需要处理
    if (templateValueList.length === 0) {
        return null;
    }
    let matchItem = null;
    if(multi && templateValueList[0].children) {
        for (let i = 0; i < templateValueList.length; i++) {
            const { children = [] } = templateValueList[i];
            const hasMatch = children.find(item => {
                return item.name === valueCN;
            });
            if (hasMatch) {
                matchItem = templateValueList[i];
                break;
            }
        }
    } else {
        matchItem = templateValueList.find(p => p.name == valueCN)
    }
   
    return matchItem;
}
/**
 * 生成抖音SKU新规范的模板数据
 * @param {*} valueItemRule
 * @returns
 */
export const gernerateDefaultSpecValueItem = (valueItemRule = {}) => {
    const { title, } = valueItemRule;
    return {
        name: title,
        nameKey: '',
        value: '',
        valueKey: genkey.get('v'),
        propId: '',
        propValueId: '',
        imageUrl: '',
        checked: true,
        extendValues: {},
    };
}

/**
 * 字段补齐（有的字段长度要严格保持一致，可以用这个方法补齐）
 * @param {Object} data 对象
 * @param {String} target 目标段
 * @param {Array} fields 要被补齐的字段
 */ 
 export const fieldFill = (data, target, fields) => {
    const len = (data[target] || []).length;
    return fields.reduce((acc, cur) => {
      acc[cur] = (data[cur] || []).concat(Array(len).fill('')).slice(0, len);
      return acc;
    }, {});
}

// 是否是组合值
export const getCombinationInputs = (feature = []) => {
    const combinationValue = feature.find(item => item.key === 'combinationValue');
    if(combinationValue && combinationValue.fvalue) {
        const fvalue = JSON.parse(combinationValue.fvalue);
        return fvalue;
    } 
    return false;
}
